module.exports = __webpack_public_path__ + "static/media/icon-calendar.9db43325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-calendar.svg
// module id = 1121
// module chunks = 1